import toGenericErrors from "@casino/legacy/client/components/Auth/Shared/utils/toGenericErrors";
import useFeature from "@casino/legacy/client/hooks/feature/useFeature";
import useSite from "@casino/legacy/client/hooks/useSite";
import deserializeErrors from "@casino/legacy/shared/utils/errors/deserializeErrors";
import { useGetAuthClearanceMutation } from "@workspace/casino_core/mutations/GetAuthClearanceMutation.client";
import { useCallback, useEffect, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const useAuthCaptchaClearance = () => {
  const [getAuthClearance] = useGetAuthClearanceMutation();
  const isRecaptchaV3Enabled = useFeature("isRecaptchaV3Enabled") ?? false;

  const [isCaptchaClearedRequired, setIsCaptchaClearedRequired] =
    useState(false);
  const { site, isBridgeSite } = useSite();
  const isRecaptchaV3 = isRecaptchaV3Enabled && !isBridgeSite;
  const { executeRecaptcha } = useGoogleReCaptcha();

  const fetchCaptchaConfigRequiredClearance = useCallback(async () => {
    if (!isRecaptchaV3) {
      return;
    }
    const captchaToken = await executeRecaptcha?.();
    const { data } = await getAuthClearance({
      input: {
        site,
        captcha: captchaToken,
        captchaVersion: "v3",
      },
    });
    const authClearanceErrors = data?.userManagementGetAuthClearance?.errors;
    if (authClearanceErrors?.length) {
      const deserializedErrors = deserializeErrors(
        toGenericErrors(authClearanceErrors),
      ) as DeserializeError;
      if (deserializedErrors?.captcha) {
        setIsCaptchaClearedRequired(true);
      }
    }
  }, [
    getAuthClearance,
    setIsCaptchaClearedRequired,
    site,
    isRecaptchaV3,
    executeRecaptcha,
  ]);

  useEffect(() => {
    if (executeRecaptcha) {
      fetchCaptchaConfigRequiredClearance();
    }
  }, [executeRecaptcha, fetchCaptchaConfigRequiredClearance]);

  return { isCaptchaClearedRequired };
};
export default useAuthCaptchaClearance;
